import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzCoaching } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_COACHING: Record<
  PageIdWoofzCoaching,
  TPageConfig
> = {
  [PageId.DOG_SELECTOR]: {
    id: PageId.DOG_SELECTOR,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.PROBLEM_DESCRIPTION]: {
    id: PageId.PROBLEM_DESCRIPTION,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageId.DOG_BREED_COACHING]: {
    id: PageId.DOG_BREED_COACHING,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageId.DOG_AGE_COACHING]: {
    id: PageId.DOG_AGE_COACHING,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageId.DOG_PROFILE_COACHING]: {
    id: PageId.DOG_PROFILE_COACHING,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageId.SUBSCRIPTIONS_COACHING]: {
    id: PageId.SUBSCRIPTIONS_COACHING,
  },
  [PageId.CANCEL_OFFER_COACHING]: {
    id: PageId.CANCEL_OFFER_COACHING,
  },
  [PageId.CALENDLY_COACHING]: {
    id: PageId.CALENDLY_COACHING,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.ALL_SET_COACHING]: {
    id: PageId.ALL_SET_COACHING,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.ACCOUNT_NOVE8]: {
    id: PageId.ACCOUNT_NOVE8,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
